import { render, staticRenderFns } from "./CheckBoxProduct.vue?vue&type=template&id=71e463bc&"
import script from "./CheckBoxProduct.vue?vue&type=script&lang=js&"
export * from "./CheckBoxProduct.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxProduct.vue?vue&type=style&index=0&id=71e463bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports